/**
 * @description
 * Возвращает результат сравнения возраста пациента с полями age места работы врача.
 * Если возраст пациента входит в диапазон age workplace - вернется результат сравнения.
 * Если передан некорректный возраст - вернется false.
 * Если передан некорректный workplace - вернется true, так как далеко не у всех врачей есть ограничение на возраст при приеме пациентов.
 * Если произошла ошибка в коде - catch вернет false.
 *
 * @param {object} opts -
 * @param {object} opts.workplace - место работы
 * @param {number | null} opts.ageNumberPatient - возраст пациента
 *
 * @returns {boolean} -
 */

function getHasSuitableAgeInWorkplace({ workplace = {}, ageNumberPatient }) {
  try {
    if (
      typeof ageNumberPatient !== 'number'
      || Number.isNaN(ageNumberPatient)
    ) {
      return false
    }

    if (!workplace?.age) {
      return true
    }

    const { min, max } = workplace.age
    const hasMinAge = typeof min === 'number' && !Number.isNaN(min)
    const hasMaxAge = typeof max === 'number' && !Number.isNaN(max)

    if (hasMinAge && hasMaxAge) {
      return ageNumberPatient >= workplace.age.min && ageNumberPatient < workplace.age.max
    }

    if (hasMinAge) {
      return ageNumberPatient >= workplace.age.min
    }

    if (hasMaxAge) {
      return ageNumberPatient < workplace.age.max
    }

    return true
  } catch {
    return false
  }
}

export default getHasSuitableAgeInWorkplace
